import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { translatedMessage } from '../service/LanguageService';

const MessagesDisplayDialogComponent = (props) => {
    const [dialogVisible, setDialogVisible] = useState(false);
    const [severityClass, setseverityClass] = useState('pi pi-check text-green-500');

    useEffect(() => {
        if (props?.severity === 'warning') {
            setseverityClass('pi pi-exclamation-triangle text-orange-500');
        } else if (props?.severity === 'error') {
            setseverityClass('pi pi-times-circle text-red-500');
        }
    }, [props]);

    useEffect(() => {
        setDialogVisible(props.visible);
    }, [props.visible]);

    const hideDialog = () => {
        if (typeof props.closeDialog === 'function') {
            props.closeDialog();
        }
        setDialogVisible(false);
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage('generic.close')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
        </>
    );

    return (
        <Dialog visible={dialogVisible} style={{ width: '600px' }} header={translatedMessage(props.dialogTitle)} modal footer={dialogFooter} onHide={hideDialog}>
            <div className="flex align-items-center">
                <i className={'mr-3 '.concat(severityClass)} style={{ fontSize: '3rem' }} />
                <div className="w-full text-align-justify align-items-center">
                    <div className="mb-3">{translatedMessage(props.dialogInfo)}</div>
                    <ul>
                        {Array.isArray(props?.messages) &&
                            props?.messages?.map((item, index) => (
                                <li key={index} className="mb-2">
                                    {props?.translate ? translatedMessage(item) : item}
                                </li>
                            ))}
                        {!Array.isArray(props?.messages) && (
                            <li key={1} className="mb-2">
                                {props?.translate ? translatedMessage(props?.messages) : props?.messages}
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </Dialog>
    );
};

export default MessagesDisplayDialogComponent;
